import { createSlice } from "@reduxjs/toolkit";

// Initial State
const initialState = {
  search: "",
  checked: [],
};

// Create Slice 
const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    changeSearch: (state, action) => {
      state.search = action.payload;
    },
    changeChecked: (state, action) => {
      const item = action.payload;

      if (state.checked.includes(item)) {
        state.checked = state.checked.filter((checkItem) => checkItem !== item);
      } else {
        state.checked.push(item);
      }
    },
    setInitialChecked: (state, action) => {
      state.checked = action.payload;
    },
  },
});

export const { changeSearch, changeChecked, setInitialChecked } =
  filterSlice.actions;
export default filterSlice.reducer;
